import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    fill="transparent"
    {...props}
  >
    <path d="M0 5C0 3.34315 1.34315 2 3 2H12L14 5.15789H21C22.6569 5.15789 24 6.50104 24 8.1579V19C24 20.6569 22.6569 22 21 22H3C1.34315 22 0 20.6569 0 19V5Z" />
  </svg>
);
